var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column"},[_c('span',{class:'cell-line-one'},[_vm._v(_vm._s(_vm.buys)+" / "+_vm._s(_vm.sells))])])}
var staticRenderFns = []

export { render, staticRenderFns }